import { Component, effect, inject, viewChild } from '@angular/core';
import { OrganizationSidebarLayout } from '../../../organizations/components/organization-sidebar-layout/organization-sidebar-layout';
import { PageHeader } from '../../../layout/components/page-header/page-header';
import { PageTitle } from '../../../layout/components/page-title/page-title';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { AnalysisDashboardHpfcKpiCard } from '../../components/analysis-dashboard-hpfc-kpi-card/analysis-dashboard-hpfc-kpi-card';
import { DocumentLmaCardList } from '../../../documents/components/document-lma-card-list/document-lma-card-list';
import { OrganizationsStore } from '../../../organizations/store/organizations.store';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { AnalysisConsumptionKpiCard } from '../../components/analysis-consumption-kpi-card/analysis-consumption-kpi-card';
import { TutorialAnalysisPopover } from '../../../tutorials/components/tutorial-analysis-popover/tutorial-analysis-popover';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';
import { VideoTutorialService } from '../../../tutorials/services/video-tutorial.service';
import { NotImplementedDirective } from '../../../../shared/directives/not-implemented';

@Component({
  selector: 'app-analysis-dashboard-page',
  imports: [
    OrganizationSidebarLayout,
    PageHeader,
    PageTitle,
    NgIcon,
    Button,
    AnalysisDashboardHpfcKpiCard,
    DocumentLmaCardList,
    TranslocoPipe,
    AnalysisConsumptionKpiCard,
    TutorialAnalysisPopover,
    FeatureEnabledDirective,
    NotImplementedDirective,
  ],
  templateUrl: './analysis-dashboard-page.html',
})
export class AnalysisDashboardPage {
  private videoTutorialService = inject(VideoTutorialService);
  private organizationsStore = inject(OrganizationsStore);
  private router = inject(Router);
  private tutorialPopover = viewChild(TutorialAnalysisPopover);

  protected organizationID = this.organizationsStore.selectedId;

  constructor() {
    effect(() => {
      const popover = this.tutorialPopover();
      if (popover && this.videoTutorialService.value()?.LumoTutorialAnalysis === false) {
        popover.showPopover();
        this.videoTutorialService.markTutorialAsViewed('LumoTutorialAnalysis');
      }
    });
  }

  protected onClickPreviewLma(documentId: string) {
    this.router.navigate(['/organizations', this.organizationID(), 'analysis', 'lma', documentId]);
  }
}
